export const meta = {
  title: 'தொடங்குங்கள்: பதிவு முதல் உங்கள் முதல் டிக்கெட் வரை',
  updatedAt: '2026-07-17',
  related: ['queue-board', 'pos', 'billing'],
};

உங்கள் காபி ஆறுவதற்குள் உங்கள் கார் கழுவும் நிலையம் இயங்கத் தொடங்கிவிடும். பதிவுப் படிவத்திலிருந்து உங்கள் முதல் டிக்கெட் நிறைவடையும் வரை இந்த வழிகாட்டி உங்களை அழைத்துச் செல்கிறது.

## 1. பதிவு செய்யுங்கள் — 30 வினாடிகள், அட்டை தேவையில்லை

**பதிவு** பக்கத்திற்குச் சென்று நான்கு விவரங்களை நிரப்புங்கள்: வணிகப் பெயர், உங்கள் பெயர், மின்னஞ்சல், கடவுச்சொல். ஒரு விற்பனை முகவர் உங்களை அறிமுகப்படுத்தியிருந்தால், அவரது குறியீடு உங்கள் இணைப்பில் ஏற்கனவே இணைந்திருக்கும் அல்லது நீங்களே தட்டச்சு செய்யலாம் — அது நீங்கள் செலுத்தும் தொகையை ஒருபோதும் மாற்றாது.

சமர்ப்பித்தவுடன் உங்கள் கணக்கு உடனடியாகச் செயல்படும்: முழு அணுகலுடன் **14 நாள் இலவசச் சோதனை**, அட்டை தேவையில்லை. தானாக உள்நுழைந்து நேரடியாக உங்கள் டாஷ்போர்டுக்கு வந்து சேர்வீர்கள்.

## 2. வரவேற்பு வழிகாட்டி

டாஷ்போர்டை முதன்முறை திறக்கும்போது, நான்கு படிகள் கொண்ட வழிகாட்டி அடிப்படைகளை அமைக்கிறது:

1. **உங்கள் கடையை உறுதிப்படுத்துங்கள்** — வாடிக்கையாளர்கள் பார்க்க வேண்டிய பெயரும் முகவரியும்.
2. **வேலை நேரம்** — வாராந்திர திறப்பு மற்றும் மூடும் நேரங்கள்.
3. **உங்கள் லோகோ** — பதிவேற்றினால், உங்கள் வாடிக்கையாளர் செயலிக்கான முழு ஐகான் தொகுப்பையும் நாங்கள் உருவாக்குகிறோம். இதைத் தவிர்த்துவிட்டு பின்னர் «பிராண்டிங்» பக்கத்தில் சேர்க்கலாம்; அதுவரை வாடிக்கையாளர்களுக்கு இடைநிலைப் படம் தெரியும்.
4. **உங்கள் வரவேற்பு அட்டை** — சோதனை நாள் எண்ணிக்கை, உங்கள் வாடிக்கையாளர் செயலி இணைப்பு, மற்றும் **வரிசையைத் திற** பொத்தான்.

முடித்தவுடன், நீங்கள் வரிசைப் பலகையில் இருப்பீர்கள் — உங்கள் குழு தினமும் பார்த்துக்கொண்டிருக்கும் திரை அதுதான்.

## 3. வாடிக்கையாளர்கள் நிற்கும் இடத்தில் உங்கள் QR-ஐ வையுங்கள்

வரிசைப் பலகையின் மேல்பட்டியில் **QR அச்சிடு**-வைத் திறங்கள். உங்கள் கடைக்கான அச்சிடத் தயாரான QR குறியீடு கிடைக்கும். நுழைவாயிலில், கவுண்டரில் — ஓட்டுநர் காத்திருக்கும் எந்த இடத்திலும் ஒட்டுங்கள்.

வாடிக்கையாளர் அதை ஸ்கேன் செய்தால், **உங்கள்** வலை செயலி திறக்கும் — உங்கள் பெயர், உங்கள் நிறங்கள், உங்கள் லோகோ. அவர்கள் கழுவும் தொகுப்பைத் தேர்ந்தெடுத்து, வாகன வகையைத் தேர்வு செய்து, எண் தகட்டை உள்ளிட்டு வரிசையில் சேர்கிறார்கள். App store இல்லை, பதிவிறக்கம் இல்லை.

## 4. உங்கள் முதல் டிக்கெட்

வாடிக்கையாளர் முன்பதிவு செய்த கணமே, சுருக்கமான டிக்கெட் எண்ணுடனும் எண் தகட்டுடனும் ஒரு டிக்கெட் உங்கள் வரிசைப் பலகையின் **வரிசையில்** பத்தியில் தோன்றும். புதிய டிக்கெட்டுகள் வரிசையின் கடைசியில் சேரும்.

அதைப் பலகையில் நகர்த்துங்கள்:

- கார் கழுவும் இடத்திற்குள் வந்ததும் **தொடங்கு** என்பதைத் தட்டுங்கள் — டிக்கெட் _கழுவப்படுகிறது_ நிலைக்கு நகரும்.
- கழுவி முடிந்ததும் **தயார்** என்பதைத் தட்டுங்கள் — «கார் தயார்» என வாடிக்கையாளருக்கு அறிவிப்புச் செல்லும்.
- டிக்கெட் இப்போது _எடுத்துச்செல்லத் தயார்_ பத்தியில் பணம் செலுத்தப்படும் வரை காத்திருக்கும்.

## 5. POS-இல் பணம் பெறுங்கள்

**POS** திரையைத் திறங்கள். எடுத்துச்செல்லத் தயாராக உள்ள ஒவ்வொரு டிக்கெட்டும் அங்கே பட்டியலிடப்பட்டிருக்கும். டிக்கெட்டைத் தட்டி, வாடிக்கையாளர் எப்படிச் செலுத்துகிறார் என்பதைத் தேர்ந்தெடுங்கள் — பணம், DuitNow QR, TNG, GrabPay, அட்டை, வங்கிப் பரிமாற்றம், வவுச்சர் அல்லது இலவசம் — பிறகு உறுதிப்படுத்துங்கள். டிக்கெட் வரலாற்றில் சேமிக்கப்படும்; வாடிக்கையாளரின் விசுவாசப் புள்ளிகள் உடனடியாக வழங்கப்படும்.

இதுதான் முழுச் சுழற்சி: ஸ்கேன் → வரிசை → கழுவல் → தயார் → பணம். இதற்குப் பிறகு வரும் அனைத்தும் — விசுவாசத் திட்டம், வவுச்சர்கள், சந்தைப்படுத்தல் — இந்த டிக்கெட்டுகளின் மேல் கட்டப்படுகின்றன.

## அடுத்து எங்கே

வரிசை மாற்றம், நிறுத்தி வைத்தல், பல கடை மாற்றம் பற்றி **வரிசைப் பலகை** கட்டுரையையும், சோதனைக் காலம் உங்கள் முதல் விலைப்பட்டியலாக மாறுவது பற்றி **பில்லிங் & உங்கள் சந்தா** கட்டுரையையும் படியுங்கள்.
